import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {AppPaymentPage} from "../app-payment/app-payment";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppAccountRemovalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-account-removal',
  templateUrl: 'app-account-removal.html',
})
export class AppAccountRemovalPage {

  private isDeletionPossible: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public apiAuth: ApiAuthProvider,
    public userState: UserStateProvider,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppAccountRemovalPage');

    if(!this.isDeletionPossible) {
      let loadingCtrl = this.loadingController.create();
      loadingCtrl.present();

      this.apiAuth.checkDelete().then((res: { status: boolean }) => {
        loadingCtrl.dismissAll();
        this.isDeletionPossible = res.status;
      })
    }
  }

  deleteAccount() {
    var loading = this.loadingController.create({})
    loading.present();

    this.apiAuth.delete().then(() => {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent("User account was deleted title"),
        subTitle: this.contentTranslation.translateContent("User account was deleted text"),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
      this.apiAuth.logout().then(() => {});
      alert.onDidDismiss(() => {
        this.navCtrl.push(IntroWelcomePage)
      })
      loading.dismissAll();
    }).catch(() => {
      loading.dismissAll();
    })
  }

  payAndDeleteAccount() {
    this.navCtrl.push(AppPaymentPage, {payAndDelete: 1})
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-account-removal/app-account-removal.ts